import {
  Button,
  Text,
  VStack,
  HStack,
  ChevronRightIcon,
} from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedBeatIdsSelector } from '../../../beats/beats.selector';
import { CustomButton } from '../../../ecg/components/CustomButton';
import { selectNextBaseCluster } from '../../thunks/select-next-base-cluster.thunk';
import {
  projectedBaseClusterSelector,
  isLastClusterSelector,
} from '../../selectors/cluster.selectors';
import { splitClusters } from '../../thunks/split-clusters.thunk';
import {
  BORDER_WIDTH,
  PADDING_RIGHT,
  STRIP_BEAT_WIDTH,
  TICK_WIDTH,
} from './BeatStrip';
import { ClassificationDropdown } from './ClassificationDropdown';
import { SortingDropdown } from './SortingDropdown';

const HEADER_WIDTH =
  STRIP_BEAT_WIDTH + TICK_WIDTH + PADDING_RIGHT + 2 * BORDER_WIDTH;

export const BeatColumnHeader: React.FC = () => {
  const dispatch = useDispatch();
  const projectedCluster = useSelector(projectedBaseClusterSelector);
  const selectedBeatIds = useSelector(selectedBeatIdsSelector);
  const isLastCluster = useSelector(isLastClusterSelector);

  const split = useCallback(async () => {
    await dispatch(splitClusters());
  }, [dispatch]);

  const selectNext = useCallback(() => {
    dispatch(selectNextBaseCluster());
  }, [dispatch]);

  if (projectedCluster == null) {
    return <></>;
  }

  return (
    <VStack alignItems='start' spacing='s'>
      <HStack justifyContent='space-between' width={HEADER_WIDTH}>
        <Text textStyle='label' flex={1}>
          All Beats ({projectedCluster?.beats.length ?? 0})
        </Text>
        <CustomButton
          size='s'
          dataTestId='split-btn'
          onClick={split}
          disabled={selectedBeatIds.size === 0}
        >
          Split ({selectedBeatIds.size})
        </CustomButton>
        <ClassificationDropdown clusters={[projectedCluster]} />
        <Button
          data-testid='next-cluster-btn'
          variant='tertiary'
          onClick={selectNext}
          rightIcon={<ChevronRightIcon />}
          isDisabled={isLastCluster}
        >
          Next
        </Button>
      </HStack>
      <SortingDropdown />
    </VStack>
  );
};
